export const normalizeCustomerUsers = (value: unknown): string[] => {
  if (Array.isArray(value)) {
    return value
      .filter((entry): entry is string => typeof entry === "string")
      .map((entry) => entry.trim())
      .filter(Boolean);
  }

  if (typeof value === "string" && value.trim()) {
    return [value.trim()];
  }

  return [];
};

export const formatCustomerUsers = (value: unknown): string =>
  normalizeCustomerUsers(value).join(", ");

export const customerIncludesUser = (
  customer: { users?: unknown; username?: unknown },
  username: string,
): boolean => {
  const normalizedUsername = username.trim();
  if (!normalizedUsername) {
    return false;
  }

  const users = normalizeCustomerUsers(customer.users ?? customer.username);
  return users.includes(normalizedUsername);
};

export const hasCustomerUsersInput = (users: string[]): boolean =>
  users.some((user) => user.trim().length > 0);

export const parseCustomerUsersField = (value: unknown): string[] => {
  if (Array.isArray(value)) {
    return normalizeCustomerUsers(value);
  }

  if (typeof value === "string") {
    const trimmed = value.trim();
    if (!trimmed) {
      return [];
    }

    try {
      const parsed = JSON.parse(trimmed);
      return normalizeCustomerUsers(parsed);
    } catch {
      return normalizeCustomerUsers(trimmed);
    }
  }

  return [];
};
